<template>

  <div class="all-cameras-list" v-if="cameras_list">
    <div class="cols">
      <div :class="[two?'two-cols':'three-cols']">
        <div class="players" 
          v-for="value in cameras_list" 
          :key="value.camera_code">
            <StreamToAllCamerasListCompoent
              :camera= "value"
            />
        </div>
      </div>
      <VueTailwindPagination
          :current="current"
          :total="total"
          :per-page="perPage"
          @page-changed="pageChange($event)"
          text-before-input="Сторiнка"
          text-after-input=""
        />
      <footer class="footer">
        <div class="text footer-text">
          Copyright © 2016-2021 OLLI GROUP
        </div> 
      </footer>
    </div>
  </div>

</template>

<script>


import VueTailwindPagination from '@ocrv/vue-tailwind-pagination'
import '../assets/styles/paginate.css'
import StreamToAllCamerasListCompoent from '../components/StreamToAllCamerasList'
import _ from 'lodash'

export default {

  components: {
    StreamToAllCamerasListCompoent, VueTailwindPagination
    },

  name: "AllCamerasListComponent",

  data () {
    return {
      cameras_list: [],
      all_cameras_list: [],
      columns: '',
      two: true,

      current: 1,
      perPage: 0,
      total: 0
    }
  },

  mounted() {
    this.all_cameras_list = JSON.parse(sessionStorage.getItem('cameras_list'))
    this.total = this.all_cameras_list.length
    this.columns = sessionStorage.getItem('columns')
    this.perPage = 4
    if (this.columns != '2') {
      this.two = false
      this.perPage = 6
    }
    this.all_cameras_list = _.chunk(this.all_cameras_list, this.perPage)
    this.pageChange(this.current)
  },

  methods: {  
    pageChange(pageNumber) {
      this.current = pageNumber
      this.cameras_list = this.all_cameras_list[pageNumber-1]
    }
  }
}


</script>

<style scoped>

  .all-cameras-list{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }

  .cols {
    height: 100vh;
    display: grid;
    align-self: start;
    grid-template-rows: 0.5fr 1fr auto;
    margin: 50px 10px 0 10px ;
  }


  .two-cols {
    display: grid;
    align-self: start;
    grid-template-columns: repeat(2, minmax(200px, 600px));
    gap: 20px;

  }

  .three-cols {
    display: grid;
    align-self: start;
    grid-template-columns: repeat(3, minmax(200px, 1250px));
    gap: 20px;
  }

  .footer {
    margin-top: 20px;
    background: #C0D72D;
    text-align: center;
  }

  .footer-text {
    color: rgb(63, 63, 63);
  }

  @media (max-height: 800px) {
    .two-cols {
      grid-template-columns: repeat(2, minmax(100px, 450px));
    }
  } 

  @media (max-width: 1280px) {
    
    .cols {
      margin: 60px 50px 0 50px 
    }
  }

  @media (max-width: 1024px) {
    
    .cols {
      margin: 80px 20px 0 20px; 
    }
  }

  @media (max-width: 800px) {
    
    .cols {
      margin: 110px 15px 0 15px 
    }
  }

  @media (max-width: 630px) {
    
    .cols {
      margin: 110px 10px 0 10px 
    }

    .three-cols {
      grid-template-columns: repeat(2, minmax(100px, 350px));
    }
  }

  @media (max-width: 450px) {
     
    .three-cols {
      grid-template-columns: repeat(1, minmax(100px, 350px));
    
    }

    .two-cols {
      grid-template-columns: repeat(1, minmax(100px, 350px));
    }

  }



</style>